import React, { useEffect, useState } from 'react';
import App from './App';
import Gallery from './pages/Gallery';

const Router: React.FC = () => {
  const [currentPath, setCurrentPath] = useState(window.location.pathname);

  useEffect(() => {
    const handleLocationChange = () => {
      setCurrentPath(window.location.pathname);
    };

    // Listen for popstate (back/forward button)
    window.addEventListener('popstate', handleLocationChange);

    // Custom event for programmatic navigation
    window.addEventListener('navigate' as any, handleLocationChange);

    return () => {
      window.removeEventListener('popstate', handleLocationChange);
      window.removeEventListener('navigate' as any, handleLocationChange);
    };
  }, []);

  // Render the appropriate component based on the current path
  if (currentPath === '/gallery') {
    return <Gallery />;
  }

  return <App />;
};

export default Router;

// Helper function for navigation
export const navigate = (path: string) => {
  window.history.pushState({}, '', path);
  window.dispatchEvent(new Event('navigate'));
  // Scroll to top of the page
  window.scrollTo(0, 0);
};
